"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactWithColor = exports.FactsShortNames = exports.NutritionValues = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const utils_1 = require("../../molecules/progress/utils");
const NutritionValues = ({ facts, unit }) => {
    if (typeof facts === "string") {
        return ((0, jsx_runtime_1.jsx)(Facts, { children: (0, jsx_runtime_1.jsx)(Fact, { children: facts }, void 0) }, void 0));
    }
    return ((0, jsx_runtime_1.jsx)(Facts, { children: Array.from(facts.keys()).map((fact) => {
            const factValue = facts.get(fact);
            return ((0, jsx_runtime_1.jsx)(Fact, { children: `${factValue} ${fact === "calories" ? "" : unit}` }, fact));
        }) }, void 0));
};
exports.NutritionValues = NutritionValues;
const Facts = styled_components_1.default.div `
  display: flex;

  & > p,
  & > h4 {
    flex: 1;
  }

  & > h4 {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }
`;
const Fact = (0, styled_components_1.default)(typography_1.P) `
  color: ${({ theme }) => theme.colors.greyBase};
  ${({ color }) => (color ? `color: ${color}` : "")};
`;
const FactsShortNames = ({ names }) => ((0, jsx_runtime_1.jsx)(Facts, { children: names.map((name) => ((0, jsx_runtime_1.jsx)(typography_1.H4, { children: name }, name))) }, void 0));
exports.FactsShortNames = FactsShortNames;
const FactWithColor = ({ facts, unit, calorieBudget, hasCalorieBudgetInfo }) => {
    if (typeof facts === "string") {
        return ((0, jsx_runtime_1.jsx)(Facts, { children: (0, jsx_runtime_1.jsx)(Fact, { children: facts }, void 0) }, void 0));
    }
    return ((0, jsx_runtime_1.jsx)(Facts, { children: Array.from(facts.keys()).map((fact) => {
            var _a, _b;
            const isCalorie = fact === "calories";
            const factValue = facts.get(fact);
            let color;
            if (isCalorie && hasCalorieBudgetInfo && ((_a = calorieBudget[fact]) === null || _a === void 0 ? void 0 : _a.status)) {
                color = (0, utils_1.resolveColor)((_b = calorieBudget[fact]) === null || _b === void 0 ? void 0 : _b.status);
            }
            return ((0, jsx_runtime_1.jsx)(Fact, { color: color, children: `${factValue} ${isCalorie ? "" : unit}` }, fact));
        }) }, void 0));
};
exports.FactWithColor = FactWithColor;
//# sourceMappingURL=NutritionValues.js.map